<template>
  <div class="FacilityCode" :style="proMode ? 'background-color:rgb(33,33,33)' : 'white'">
    <QAReviewer />
  </div>
</template>

<script>
// @ is an alias to /src
import QAReviewer from '@/components/QAReviewer.vue';
import { mapGetters } from "vuex";

export default {
  name: 'QAReview',
  components: {
    QAReviewer
  },
  computed: {
        ...mapGetters(["userprof","proMode","facSettings"]),
  },
  mounted(){
  },
  methods:{
    
  }
}
</script>
